/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { combinationsDependencies } from './dependenciesCombinations.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { isIntegerDependencies } from './dependenciesIsInteger.generated';
import { isNegativeDependencies } from './dependenciesIsNegative.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCatalan } from '../../factoriesAny.js';
export var catalanDependencies = {
  addScalarDependencies: addScalarDependencies,
  combinationsDependencies: combinationsDependencies,
  divideScalarDependencies: divideScalarDependencies,
  isIntegerDependencies: isIntegerDependencies,
  isNegativeDependencies: isNegativeDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  typedDependencies: typedDependencies,
  createCatalan: createCatalan
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCatalan.generated.js
// module id = 1499
// module chunks = 0